module.exports = __webpack_public_path__ + "static/media/back-arrow.f9c0ccfe.svg";